const getPublic = (file) => `${process.env.PUBLIC_URL}/${file}`;

export default getPublic;
